<ng-container *ngIf="(membershipProcessing$ | async); else showContent">
  <ng-container *ngIf="!isWithinPage; else displayLoadingWithinPage">
    <!-- Be A Member button on navbar -->
    <button class="btn btn-primary btn-membership in-navbar w-100 py-1 px-4 d-lg-block d-none">
      <mat-spinner [diameter]="17" class="mx-auto"></mat-spinner>
    </button>
    <button class="btn btn-primary btn-membership w-100 py-2 px-4 d-lg-none d-block">
      <mat-spinner [diameter]="17" class="mx-auto"></mat-spinner>
    </button>
  </ng-container>
  <ng-template #displayLoadingWithinPage>
    <!-- Be A Member within page -->
    <button class="btn btn-primary w-100 mb-3" *ngIf="!isWithinUnlockPage">
      <mat-spinner [diameter]="15" class="mx-auto"></mat-spinner>
    </button>
    <!-- Be A Member within Unlock This Workout overlay -->
    <button class="btn btn-primary btn-within-unlock-page w-100 py-1 px-4" *ngIf="isWithinUnlockPage">
      <mat-spinner [diameter]="17" class="mx-auto"></mat-spinner>
    </button>
  </ng-template>
</ng-container>

<ng-template #showContent>
  <ng-container [ngSwitch]="hasMembership" *ngIf="!isWithinPage; else displayWithinPage">
    <!-- Be A Member button on navbar -->
    <span *ngSwitchCase="true">
      <span *ngIf="!freeSubscription">
        <button class="btn btn-primary btn-membership w-100 py-2 px-4 d-lg-block d-none" matBadge="!"
          (click)="getMembershipButtonClick()" [matBadgeHidden]="remainingDays > 7 && membershipStatus === 'Active'">
          {{ membershipStatusDisplay | translate }}
        </button>
        <button class="btn btn-primary btn-membership w-100 py-3 px-4 d-lg-none d-block" matBadge="!"
          (click)="getMembershipButtonClick()" [matBadgeHidden]="remainingDays > 7 && membershipStatus === 'Active'">
          {{ membershipStatusDisplay | translate }}
        </button>
      </span>

      <span *ngIf="freeSubscription && !hasActivePartnerSubscriptions">
        <button class="btn btn-primary btn-membership w-100 py-2 px-4 d-lg-block d-none" matBadge="!"
          (click)="getMembershipButtonClick()" [matBadgeHidden]="remainingDays > 7 && membershipStatus === 'Active'">
          Free Membership
        </button>
      </span>

      <span *ngIf="freeSubscription && hasActivePartnerSubscriptions">
        <button class="btn btn-primary btn-membership w-100 py-2 px-4 d-lg-block d-none" matBadge="!"
          (click)="getMembershipButtonClick()">
          Upgrade Your Free Membership
        </button>
      </span>
    </span>
    <span *ngSwitchCase="false">
      <button class="btn btn-primary btn-membership w-100 py-2 px-4 d-lg-block d-none"
        (click)="getMembershipButtonClick()">
        {{ 'toolbars.beAMemberButtonText' | translate }}
      </button>
      <button class="btn btn-primary btn-membership w-100 py-3 px-4 d-lg-none d-block"
        (click)="getMembershipButtonClick()">
        {{ 'toolbars.beAMemberButtonText' | translate }}
      </button>
    </span>
  </ng-container>
  <ng-template #displayWithinPage>
    <!-- Be A Member within page -->
    <button class="btn btn-primary w-100 mb-3" (click)="getMembershipButtonClick()"
      *ngIf="!isWithinUnlockPage && !isTicketMembershipsOnly && !freeSubscription && membershipStatus !== 'Pending'">
      {{ 'toolbars.beAMemberButtonText' | translate }}
    </button>
    <!-- Be A Member within Unlock This Workout overlay -->
    <button class="btn btn-primary btn-within-unlock-page w-100 py-2 px-4"
      *ngIf="isWithinUnlockPage  && !isTicketMembershipsOnly && !freeSubscription  && membershipStatus !== 'Pending'"
      (click)="getMembershipButtonClick()">
      {{ 'toolbars.beAMemberButtonText' | translate }}
    </button>

    <!-- Be A Member within page for ticket application-->
    <button class="btn btn-primary w-100 mb-3" (click)="getMembershipButtonClick()" matBadge="!"
      *ngIf="!isWithinUnlockPage && isTicketMembershipsOnly && !freeSubscription">
      No Ticket Left. Apply Now.
    </button>

    <button class="btn btn-primary w-100 mb-3" (click)="getMembershipButtonClick()" matBadge="!"
      *ngIf="isTicketMembershipsOnly && freeSubscription && hasActivePartnerSubscriptions">
      Upgrade Your Free Membership
    </button>
  </ng-template>
</ng-template>